import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function PaymentSuccessIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M27.5 14.375V7.64246C27.5 6.65374 27.5 6.15939 27.2574 5.64957C27.119 5.35881 26.8037 4.9633 26.5512 4.76349C26.1085 4.41314 25.739 4.32851 25 4.15925C23.8504 3.89594 22.5824 3.75 21.25 3.75C18.8536 3.75 16.6656 4.22205 15 5C13.3344 5.77795 11.1463 6.25 8.75 6.25C7.4176 6.25 6.14961 6.10406 5 5.84075C3.80004 5.56591 2.5 6.41142 2.5 7.64246V21.1075C2.5 22.0962 2.5 22.5906 2.74265 23.1004C2.88104 23.3911 3.1962 23.7867 3.44873 23.9865C3.89149 24.3369 4.261 24.4215 5 24.5907C6.14961 24.8541 7.4176 25 8.75 25C10.5861 25 12.2998 24.7229 13.75 24.2434"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M17.5 23.75C17.5 23.75 18.75 23.75 20 26.25C20 26.25 23.9706 20 27.5 18.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M18.125 14.375C18.125 16.1009 16.7259 17.5 15 17.5C13.2741 17.5 11.875 16.1009 11.875 14.375C11.875 12.6491 13.2741 11.25 15 11.25C16.7259 11.25 18.125 12.6491 18.125 14.375Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        fill="none"
        d="M6.875 15.625V15.6362"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M23.125 13.1172V13.1284"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
